import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLaravelComponent } from './simple-icons-laravel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLaravelComponent ],
    exports:      [ SimpleIconsLaravelComponent ],
    bootstrap:    []
})
export class SimpleIconsLaravelModule {}
